import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

export interface ReadonlyFieldProps {
  children: ReactNode
  className?: string
}

export function ReadonlyField({ children, className }: ReadonlyFieldProps) {
  return (
    <div
      className={cn(
        'flex min-h-[38px] w-full items-center rounded-lg border border-[var(--color-control-border)] bg-[var(--color-surface-muted)] px-3 py-1.5 text-sm font-medium leading-5 break-words text-[var(--color-text)]',
        className,
      )}
    >
      {children}
    </div>
  )
}
